import type { FC } from "react";
import type {
  EmailWithStatus,
  SelectContextMenuHandler,
} from "routes/emails/SearchEmailsPage";
import { HREmailsTableUI } from "routes/emails/SearchEmailsPage/components/HREmailsTable";
import { MatterEmailsTableUI } from "routes/emails/SearchEmailsPage/components/MatterEmailsTable";

export type EmailsTableUIProps = {
  isMatter: boolean;
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  onSelectContextMenu: SelectContextMenuHandler;
  onToggleFavoriteEmail: (emailId: string, favorite: boolean) => void;
  freeWords: string[];
};

export const EmailsTableUI: FC<EmailsTableUIProps> = ({
  isMatter,
  emails,
  onSelectEmail,
  onSelectContextMenu,
  onToggleFavoriteEmail,
  freeWords,
}) => {
  return isMatter ? (
    <MatterEmailsTableUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      onSelectContextMenu={onSelectContextMenu}
      onToggleFavoriteEmail={onToggleFavoriteEmail}
      freeWords={freeWords}
    />
  ) : (
    <HREmailsTableUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      onSelectContextMenu={onSelectContextMenu}
      onToggleFavoriteEmail={onToggleFavoriteEmail}
      freeWords={freeWords}
    />
  );
};
